module.exports = __webpack_public_path__ + "static/img/icon_ranking.ba6e6b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/icon_ranking.png
// module id = Ph2/
// module chunks = 96